import styled from 'styled-components';

import colors from '../../../../../theme/colors';
import media from '../../../../../theme/media';

const getBorder = (props) => {
    if (props.noBorder) {
        return 'transparent';
    } else {
        switch (props.variant) {
            case 'secondary':
                return colors.purpleRgba08;
            case 'tertiary':
                return colors.superLightGray;
            case 'letterIndex':
                return colors.baseColor;
            case 'selectedPassive':
                return colors.purpleRgba40;
            default:
                return colors.white;
        }
    }
};

export const DiskBadgeContainer = styled.span`
    display: inline-flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    border-radius: 50%;
    width: ${(props) => (props.diskSize === 'x-large' ? '120px' : '40px')};
    height: ${(props) => (props.diskSize === 'x-large' ? '120px' : '40px')};
    background: ${(props) => (props.variant === 'secondary' ? colors.purpleRgba08 : props.variant === 'selectedPassive' ? colors.whiteRgba72 : colors.white)};
    border: ${(props) => (props.variant === 'letterIndex' ? '2px' : '1px')} solid ${(props) => getBorder(props)};
    position: relative;
`;

export const ImgWrap = styled.span`
    width: ${(props) => (props.diskSize === 'x-large' ? '116px' : '40px')};
    height: ${(props) => (props.diskSize === 'x-large' ? '116px' : '40px')};
    flex-shrink: 0;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
    border-radius: 50%;

    img {
        width: 100%;
        max-width: 100%;
        border-radius: 50%;
    }
`;

export const FlagIconWrap = styled.span`
    position: absolute;
    right: -4px;
    bottom: -4px;
    border: 2px solid ${colors.white};
    border-radius: 50%;
    display: inline-flex;
    background: ${colors.white};
    z-index: 1;

    ${media.desktop1920} {
        right: -2px;
        bottom: -2px;
    }
`;
export const FlagIconContainer = styled.span`
    display: inline-flex;
`;
export const SecondFlagIconWrap = styled.span`
    position: absolute;
    right: -14px;
    bottom: -4px;
    border: 2px solid ${colors.white};
    border-radius: 50%;
    display: inline-flex;
    background: ${colors.white};

    ${media.desktop1920} {
        right: -12px;
        bottom: -2px;
    }
`;
